import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router';
import { useRouteMatch } from 'react-router-dom';
import PageLoader from '@jumbo/components/PageComponents/PageLoader';
import { ADMIN_TYPES, MANAGER_TYPES } from 'constants/Systems';

const Download = () => {
  const match = useRouteMatch();
  const authUser = useSelector(({ auth: { authUser } }) => authUser);

  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Route path={`${match.url}/customer-list`} component={lazy(() => import('./CustomerList'))} />
        <Route path={`${match.url}/interview`} component={lazy(() => import('./Interview'))} />
        <Route path={`${match.url}/dropoff`} component={lazy(() => import('./DropOff'))} />
        <Route path={`${match.url}/topline`} component={lazy(() => import('./Topline'))} />
        <Route path={`${match.url}/topline-pdf`} component={lazy(() => import('./ToplinePdf'))} />
        {authUser && (ADMIN_TYPES.includes(authUser.type) || MANAGER_TYPES.includes(authUser.type)) && (
          <Route path={`${match.url}/topline-pivot`} component={lazy(() => import('./ToplinePivot'))} />
        )}
        {authUser && ADMIN_TYPES.includes(authUser.type) && (
          <Route path={`${match.url}/monthly-report`} component={lazy(() => import('./MonthlyReport'))} />
        )}

        <Route component={lazy(() => import('../../error/Error404'))} />
      </Switch>
    </Suspense>
  );
};

export default Download;
